import { CustomButton } from '../../../features/customButton';
import { useVisibleExtraButton } from '../../../../hooks/shared/quests/useVisibleExtraButton';
import classNames from 'classnames';
import { useClickOnExtraButton } from '../../../../hooks/shared/quests/useClickOnExtraButton';
import { useQuestFlags } from '../../../../hooks/shared/quests/useQuestFlags';
import { tasksContent } from '../../../../constants/copyright';

const {
  buttons: { extraButton },
} = tasksContent;

export default function TaskItemExtraButton({ quest }) {
  const isVisible = useVisibleExtraButton({ quest });
  const onClick = useClickOnExtraButton({ quest });
  const { isChallenge } = useQuestFlags({ quest });

  return (
    isVisible && (
      <CustomButton
        className={classNames(extraButton.className, { 'custom-button_challenge': isChallenge })}
        {...extraButton}
        onClick={onClick}
      />
    )
  );
}
